import xlsx from 'xlsx'
import { cloneDeep } from 'lodash'

import { appendSheet } from '../../../../BottomHeader/BotButtons/ExportXlsxButtonService'

export function createXlsxData(sheetName: string, xlsBotRows: string[][]) {
  const xlsxCopy = cloneDeep(xlsx)
  const workBook = xlsxCopy.utils.book_new()
  appendSheet(xlsBotRows, sheetName, workBook, xlsxCopy, false)

  return xlsxCopy.write(workBook, { type: 'array', bookSST: false, bookType: 'xlsx' })
}
